export const home = {
  homeHerder: {
    title1: "Home",
    title2: "Task",
    title3: "Integral",
    title4: "Activity",
    title5: "Help",
    title6: "Commerce",
    title7: "Login",
    title8: "sign up",
    title9: "Log out and log in",
  },
  mobileHerder: [
    {
      name: "home page",
      type: 1,
      path: "/home",
    },
    {
      name: "home page",
      type: 2,
      children: [
        {
          name: "My homepage",
          path: "/module/home",
        },
        {
          name: "Task Record",
          path: "/module/taskRecord",
        },
        {
          name: "Redemption History",
          path: "/module/redemptionHistory",
        },
        {
          name: "Gold coin details",
          path: "/module/goldHistory",
        },
        {
          name: "Account settings",
          path: "/module/account",
        },
        {
          name: "My invitation",
          path: "/module/invite",
        },
        {
          name: "My credit value",
          path: "/module/creditValue",
        },
      ],
    },
    {
      name: "Task",
      type: 3,
      path: "/module/task",
    },
    {
      name: "Exchange",
      type: 3,
      path: "/module/exchange",
    },
    {
      name: "Activity",
      type: 3,
      path: "/module/activity",
    },
    {
      name: "Help",
      type: 3,
      path: "/module/help",
    },
    {
      name: "Login/sign up",
      type: 3,
      path: "/login",
    },
    {
      name: "Log out and log in",
      path: "/login",
      type: 3,
    },
  ],
  mobileHerder2: [
    {
      name: "home page",
      path: "/home",
    },
    {
      name: "Task",
      path: "/module/task",
    },
    {
      name: "Exchange",
      path: "/module/exchange",
    },
    {
      name: "Activity",
      path: "/module/activity",
    },
    {
      name: "Help",
      path: "/module/help",
    },
    {
      name: "Commerce",
      path: "/commerce",
    },
    {
      name: "Login/sign up",
      path: "/login",
    },
  ],
  page1: {
    title1: "Share new perspectives",
    title2: "Assist in a better life",
    title3:
      "'Love Answers' is a paid participation platform for research tasks. You can visit us through WeChat official account and computers to participate in research tasks and obtain cash returns. More than 97000 research tasks have been published and more than 550 million rewards have been issued",
    title4: "Learn more",
  },
  page2: {
    title1: "How to obtain rewards",
    tips1: "AiDaJuan,Three steps,Receive red envelopes",
    boxs1: {
      title1: "Register to join",
      title2:
        "Complete the information to have more tasks waiting for you to participate in",
    },
    boxs2: {
      title1: "Participate in tasks",
      title2: "Lucky tasks/daily tasks are up to you",
    },
    boxs3: {
      title1: "Redeem rewards",
      title2: "WeChat red envelope/Alipay red envelope",
    },
  },
  page5: {
    title1: "They are using the AiDaJuan",
    tips1: "AiDaJuan,Received consecutive red envelopes",
    boxs1: "Accumulated research tasks have been released",
    boxs2: "Accumulated research tasks have been released",
    boxs3: "Accumulated cash rewards have been distributed",
  },
  footer: {
    title1:
      "Join AiDaJuan,Participate in the questionnaire,Release your influence!",
    title2: "Start answering",
    title3: "About AiDaJuan",
    title4: "Company",
    title5: "About us",
    title6: "Join us",
    title7: "Support",
    title8: "Help Center",
    title9: "Commerce",
    title10: "About",
    title11: "Service Agreement",
    title12: "Privacy Policy",
    title13: "Disclaimers",
    title14: "WeChat",
    title15: "Contact",
  },
};
